import React from "react";

// Real "Location RNC" logo (PNG extracted from user's PDF).
export const Logo = ({ size = 64, withText = false, className = "", inverted = false }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/logo.png"
        alt="Location RNC — Remorques & Outillage"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
      />
      {withText && (
        <div className="leading-none">
          <div className={`font-display text-2xl tracking-wide transition-colors ${inverted ? "text-white" : "text-[#1A4E72]"}`}>
            LOCATION <span className="text-[#E87B3A]">RNC</span>
          </div>
          <div className={`font-body text-[10px] font-bold tracking-[0.25em] uppercase mt-1 transition-colors ${inverted ? "text-white/70" : "text-[#475569]"}`}>
            Remorques &amp; Outillage
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
